import type { DeepPartial } from '@apollo/client/utilities';

import type {
  AmericanFootballFixture,
  FootballFixture,
  TennisMatch
} from '@swf/generated/graphql/scoreboards/schemas';

import { EventTypeId } from '../types/eventType';

export type LiveData =
  | DeepPartial<FootballFixture>
  | DeepPartial<TennisMatch>
  | DeepPartial<AmericanFootballFixture>;

export const getIsAmericanFootballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is AmericanFootballFixture => eventTypeId === EventTypeId.AMERICAN_FOOTBALL;

export const getIsFootballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is FootballFixture => eventTypeId === EventTypeId.SOCCER;

export const getIsTennisLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is TennisMatch => eventTypeId === EventTypeId.TENNIS;
